import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

// app
import { adminAxios } from '../../admin.api';
import { CLIENT_OFFICE_LIST, OPERATIONAL_CLIENTS } from '../../queryKeys';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';
import { enqueueNotification, hideModal } from 'stores';

export const useCreateClientOffice = () => {
  const dispatch = useDispatch();

  const queryClient = useQueryClient();

  const handleSettled = (data) => {
    dispatch(hideModal());
  };

  const handleError = (err) => {
    const errorParams = {
      file: 'admin.mutations.createClientOffice',
      message: 'API fetch error (admin.post)',
    };
    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
    dispatch(enqueueNotification('notification.admin.officePostFail', 'error'));
  };

  const handleSuccess = (res) => {
    const { data } = res;
    queryClient.invalidateQueries(OPERATIONAL_CLIENTS);
    queryClient.invalidateQueries(CLIENT_OFFICE_LIST);
    dispatch(
      enqueueNotification('notification.admin.officePostSuccess', 'success', {
        data: { officeName: data?.name, clientName: data?.parent && data?.parent.name },
      })
    );
  };

  return useMutation(
    async (data) => {
      return await adminAxios.post('client/office', data);
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      onSettled: (data) => handleSettled(data),
    }
  );
};
